import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueCookies from "vue-cookies";
import VueMeta from "vue-meta";
import VueGtag from "vue-gtag";
import VueLocalStorage from "vue-localstorage";

import VueMoment from "vue-moment";
import moment from "moment-timezone";
require("moment/locale/es-mx");

/* Custom Style */
import "@/assets/css/gobmx.css";
import "@/assets/css/styles.css";
import "@/assets/css/fonts.css";

Vue.config.productionTip = false;
Vue.use(VueLocalStorage);
Vue.use(VueMeta);

Vue.use(VueCookies, {
	expires: "1d",
});

Vue.use(VueMoment, {
	moment,
});

Vue.use(VueGtag, {
	config: {
		id: "G-QSCB42GFHB",
		params: {
			send_page_view: true,
		},
	},
	//router,
});

new Vue({
	router,
	store,
	vuetify,
	render: function (h) {
		return h(App);
	},
}).$mount("#app");
